import { VFileInput } from 'vuetify/lib/components/VFileInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card__default"},[_c('h3',[_vm._v("Изображения")]),_c(VFileInput,{attrs:{"accept":"image/*","label":"Логотип"}}),_c(VFileInput,{attrs:{"accept":"image/*","label":"Задний фон"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }